import { createSlice } from '@reduxjs/toolkit';
import { selectedProductActionTypes } from '../utils';

const selectedProductDetailsSlice = createSlice({
  name: 'selectedProductDetails',

  initialState: {
    variantID: null,
    productID: null,
    itemExchangeAllowed: null,
    returnAllowed: null,
    selectedProductImage: null,
    shopifySelectedProductImage: null,
    selectedProductPrice: null,
    lineItemID: null,
    lineItemLocationId: null,
    selectedQuantity: null,
    storeCreditApplicable: true,
    originalPaymentApplicable: true,
    shopifyRedirection: null,
    configuredPolicyViolatedMessage: null,
  },

  reducers: {
    updateSelectedProductDetails: (state, action) => {
      const { key, value } = action.payload;

      switch (key) {
        case selectedProductActionTypes.SET_VARIANT_ID:
          state.variantID = value;
          break;
        case selectedProductActionTypes.SET_PRODUCT_ID:
          state.productID = value;
          break;
        case selectedProductActionTypes.SET_ITEM_EXCHANGE_ALLOWED:
          state.itemExchangeAllowed = value;
          break;
        case selectedProductActionTypes.SET_RETURN_ALLOWED:
          state.returnAllowed = value;
          break;
        case selectedProductActionTypes.SET_SELECTED_PRODUCT_IMAGE:
          state.selectedProductImage = value;
          break;
        case selectedProductActionTypes.SET_SHOPIFY_SELECTED_PRODUCT_IMAGE:
          state.shopifySelectedProductImage = value;
          break;
        case selectedProductActionTypes.SET_SELECTED_PRODUCT_PRICE:
          state.selectedProductPrice = value;
          break;
        case selectedProductActionTypes.SET_LINE_ITEM_ID:
          state.lineItemID = value;
          break;
        case selectedProductActionTypes.SET_LINE_ITEM_LOCATION_ID:
          state.lineItemLocationId = value;
          break;
        case selectedProductActionTypes.SET_SELECTED_ITEM_QUANTITY:
          state.selectedQuantity = value;
          break;
        case selectedProductActionTypes.SET_STORE_CREDIT_APPLICABLE:
          state.storeCreditApplicable = value;
          break;
        case selectedProductActionTypes.SET_ORIGINAL_PAYMENT_APPLICABLE:
          state.originalPaymentApplicable = value;
          break;
        case selectedProductActionTypes.SET_SHOPIFY_REDIRECTION:
          state.shopifyRedirection = value;
          break;
        case selectedProductActionTypes.UPDATE_CONFIGURED_POLICY_VIOLATED_MESSAGE:
          state.configuredPolicyViolatedMessage = value;
          break;
        default:
      }
    },
  },
});

// Export the slice
export { selectedProductDetailsSlice };

// Export the actions
export const { updateSelectedProductDetails } =
  selectedProductDetailsSlice.actions;

// Export the reducer
export default selectedProductDetailsSlice.reducer;
